@if (isVisible) {
<span>
  <i class="{{ fontAwesomeIconClass }}" [title]="notificationTitle"></i>
  &nbsp;
</span>
}
